export const anstellungstyp = {
  VOLLZEIT: 'VOLLZEIT',
  TEILZEIT: 'TEILZEIT',
  AZUBI: 'AZUBI',
  MIDIJOB: 'MIDIJOB',
  MINIJOB: 'MINIJOB',
  KURZ_MIT_LSTK: 'KURZ_MIT_LSTK',
  KURZ_OHNE_LSTK: 'KURZ_OHNE_LSTK',
  WERKSTUDENT: 'WERKSTUDENT',
  SELBSTSTAENDIG: 'SELBSTSTAENDIG',
  PRAKTIKANT: 'PRAKTIKANT',
  EHRENAMTLICH: 'EHRENAMTLICH',
} as const;

export type Anstellungstyp = keyof typeof anstellungstyp;
